var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.5V5.5C20.5 4.39543 19.6046 3.5 18.5 3.5H14.5M5.5 3.5H7.5C8.60457 3.5 9.5 4.39543 9.5 5.5V7.5C9.5 8.60457 8.60457 9.5 7.5 9.5H5.5C4.39543 9.5 3.5 8.60457 3.5 7.5V5.5C3.5 4.39543 4.39543 3.5 5.5 3.5ZM5.5 14.5H7.5C8.60457 14.5 9.5 15.3954 9.5 16.5V18.5C9.5 19.6046 8.60457 20.5 7.5 20.5H5.5C4.39543 20.5 3.5 19.6046 3.5 18.5V16.5C3.5 15.3954 4.39543 14.5 5.5 14.5ZM16.5 14.5H18.5C19.6046 14.5 20.5 15.3954 20.5 16.5V18.5C20.5 19.6046 19.6046 20.5 18.5 20.5H16.5C15.3954 20.5 14.5 19.6046 14.5 18.5V16.5C14.5 15.3954 15.3954 14.5 16.5 14.5ZM16 6.5C15.1716 6.5 14.5 7.17157 14.5 8C14.5 8.82843 15.1716 9.5 16 9.5C16.8284 9.5 17.5 8.82843 17.5 8C17.5 7.17157 16.8284 6.5 16 6.5Z",
    stroke: "#F2F5F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.e5d3deb4d8d7dd2479934ff8bc31593a.svg";
export { ForwardRef as ReactComponent };